import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class DialogService {

    constructor(private dialog: MatDialog) { }

    // public openDialog(component): void {
    //     const dialogConfig = new MatDialogConfig();
    //     switch (component) {
    //         case 'privacy-policy': {
    //             this.dialog.open(PrivacyComponent, dialogConfig);
    //             break;
    //         }
    //         case 'terms-of-service': {
    //             this.dialog.open(TosComponent, dialogConfig);
    //             break;
    //         }
    //         default:
    //             break;
    //     }

    // }
}
